// Read-of-record label for a broadcast's audience (list rows, detail page),
// in the composer's vocabulary. A `filter` spec names its facets; a
// facet-less one is "All members".

import type { useTranslations } from '@/i18n/translations';
import type { components } from '@leanin/api-client';

import { COUNTRIES } from '@/components/CountryPicker';

type AudienceSpec = components['schemas']['AudienceSpec'];
type AudienceTranslate = ReturnType<typeof useTranslations<'Admin.broadcasts.audience'>>;

const COUNTRY_NAMES = new Map(COUNTRIES.map((c) => [c.code, c.name]));

export function audienceLabel(spec: AudienceSpec, t: AudienceTranslate): string {
  if (spec.kind !== 'filter') return t(`kind.${spec.kind}`);
  const parts: string[] = [];
  if (spec.communityRoles !== undefined) {
    parts.push(spec.communityRoles.map((role) => t(`roles.${role}`)).join(', '));
  }
  if (spec.country !== undefined) {
    const countries = spec.country.codes.map((code) => COUNTRY_NAMES.get(code) ?? code).join(', ');
    parts.push(spec.country.includeUnknown ? t('countryWithUnknown', { countries }) : countries);
  }
  if (spec.recentActiveDays !== undefined) {
    parts.push(t('activeWithinDays', { days: spec.recentActiveDays }));
  }
  return parts.length === 0 ? t('kind.filter') : parts.join(' · ');
}
